// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_nhPdi","nav":"index_nav_fBJkx clearfix","list":"index_list_8kUVE"};